const LEGACY_PREFIX = 'RaspberryJamMod_';

const INPUT_REMAP = {
    minecraft_setHost: {opcode: `${LEGACY_PREFIX}connect_p`, inputs: {TEXT: 'ip'}},
    minecraft_chat: {opcode: `${LEGACY_PREFIX}chat`, inputs: {TEXT: 'msg'}},
    minecraft_setBlock: {opcode: `${LEGACY_PREFIX}setBlock`, inputs: {BLOCK: 'b', STARTX: 'x', STARTY: 'y', STARTZ: 'z'}},
    minecraft_spawnEntity: {opcode: `${LEGACY_PREFIX}spawnEntity`, inputs: {ENTITY: 'entity', STARTX: 'x', STARTY: 'y', STARTZ: 'z'}},
    minecraft_teleport: {opcode: `${LEGACY_PREFIX}setPlayerPos`, inputs: {STARTX: 'x', STARTY: 'y', STARTZ: 'z'}}
};

const DROP_OPCODES = new Set([
    'minecraft_getPlayerPosition'
]);

const remapInputs = (block, inputRemap) => {
    const inputs = {};
    Object.entries(block.inputs || {}).forEach(([name, value]) => {
        const mappedName = inputRemap[name] || name;
        inputs[mappedName] = value;
    });
    return inputs;
};

const rewriteBlock = block => {
    if (!block || !block.opcode) return block;
    if (DROP_OPCODES.has(block.opcode)) return null;

    const mapping = INPUT_REMAP[block.opcode];
    if (!mapping) return block;

    return Object.assign({}, block, {
        opcode: mapping.opcode,
        inputs: remapInputs(block, mapping.inputs)
    });
};

/**
 * Rewrite compiled example blocks to legacy RaspberryJamMod opcodes when possible.
 * @param {Array<object>} blocks - compiled example blocks
 * @returns {Array<object>}
 */
export const rewriteExampleBlocksForLegacy = blocks => {
    const rewritten = blocks
        .map(rewriteBlock)
        .filter(Boolean);

    const idMap = Object.create(null);
    blocks.forEach((block, index) => {
        if (block && block.id && rewritten[index] && rewritten[index].id) {
            idMap[block.id] = rewritten[index].id;
        }
    });

    // Drop removed blocks and fix next/parent/input references.
    const keptIds = new Set(rewritten.map(block => block.id));
    const droppedIds = new Set(
        blocks.map(block => block.id).filter(id => !keptIds.has(id))
    );

    return rewritten.map(block => {
        const clone = Object.assign({}, block, {
            inputs: Object.assign({}, block.inputs)
        });

        if (clone.next && droppedIds.has(clone.next)) {
            let cursor = blocks.find(entry => entry.id === clone.next);
            while (cursor && droppedIds.has(cursor.id)) {
                cursor = blocks.find(entry => entry.id === cursor.next);
            }
            clone.next = cursor ? cursor.id : null;
        }

        Object.keys(clone.inputs).forEach(inputName => {
            const input = clone.inputs[inputName];
            if (input && input.block && droppedIds.has(input.block)) {
                clone.inputs[inputName] = Object.assign({}, input, {block: null, shadow: input.shadow});
            }
        });

        return clone;
    });
};
